import { Validators } from '@angular/forms';
import { PasswordValidators } from 'ngx-validators';
// todo: find a better place for this file
export const passwordValidators = [
  Validators.minLength(8),
  Validators.maxLength(64),
  PasswordValidators.lowercaseCharacterRule(1),
  PasswordValidators.uppercaseCharacterRule(1),
  PasswordValidators.digitCharacterRule(1),
];

export const passwordErrorsI18n = {
  minlength: 'ng/i18n.ERROR.PASSWORD_RULES_ERROR',
  maxlength: 'ng/i18n.ERROR.PASSWORD_RULES_ERROR',
  uppercaseCharacterRule: 'ng/i18n.ERROR.PASSWORD_RULES_ERROR',
  digitCharacterRule: 'ng/i18n.ERROR.PASSWORD_RULES_ERROR',
  lowercaseCharacterRule: 'ng/i18n.ERROR.PASSWORD_RULES_ERROR',
};
